import { RecordType } from '@modules/planning/children/scheme-editor/types';

export const sortByKeys = (data: Array<RecordType>, descend?: boolean) =>
  data.sort((a, b) => {
    const k = descend ? -1 : 1;
    return a.key > b.key ? k : b.key > a.key ? -k : 0;
  });
